
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 41","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.969.313L25 3.75 20.703.312C20.547.157 20.156 0 20 0c-.234 0-.625.156-.781.313L15 3.75 10.703.312C10.547.157 10.156 0 10 0c-.234 0-.625.156-.781.313L5 3.75 1.953.312C1.172-.313 0 .234 0 1.25v37.5c0 1.094 1.172 1.64 1.953 1.016L5 36.25l4.219 3.516c.156.156.547.312.781.312.156 0 .547-.156.703-.312L15 36.25l4.219 3.516c.156.156.547.312.781.312.156 0 .547-.156.703-.312L25 36.25l2.969 3.516c.781.625 2.031.078 2.031-1.016V1.25c0-1.016-1.172-1.563-2.031-.938zM25 28.125c0 .39-.313.625-.625.625H5.625c-.39 0-.625-.234-.625-.625v-1.25c0-.313.234-.625.625-.625h18.75c.313 0 .625.313.625.625v1.25zm0-7.5c0 .39-.313.625-.625.625H5.625c-.39 0-.625-.234-.625-.625v-1.25c0-.313.234-.625.625-.625h18.75c.313 0 .625.313.625.625v1.25zm0-7.5c0 .39-.313.625-.625.625H5.625c-.39 0-.625-.234-.625-.625v-1.25c0-.313.234-.625.625-.625h18.75c.313 0 .625.313.625.625v1.25z","fill":"currentColor"}})])
          )
        }
      }
    